import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import EventList from "./EventList";
import CreateEvent from "./CreateEvent";
import EditEvent from "./EditEvent";
import ViewEvent from "./ViewEvent";
import { Toaster } from 'react-hot-toast';
import RegistrationForm from "./components/RegistrationForm";
import EmailForm from "./components/EmailForm";
import SimpleRegistration from "./components/SimpleRegistration";
import EventQuestionsForm from "./components/EventQuestionsForm";
import RegistrationDetails from "./components/RegistrationDetails";
import CreateRevenueEvent from "./CreateReveueEvent";
import RevenueViewEvent from "./RevenueViewEvent";
import MapBoxGPSComponent from "./components/MapBoxGPSComponent";
import MapWithGpx from "./components/MapWithGPX";
import OTGMapWithGpx from "./components/OTGMapWithGPX";
import OTGEventsMap from "./components/OTGEventsMaps";
import CampMap from "./components/CampMap";
import CampDataUpload from "./components/CampDataUpload";
import CampDetailsEditor from "./components/CampDetailsEditor";
import AddLocationForm from "./components/AddLocationForm";
import CampDetailsView from "./components/CampDetailsView";
import AuditLog from "./components/AuditLog";
import SiteReportForm from "./components/SiteReportForm";
import SiteReportsView from "./components/SiteReportsView";
import UserStatsReport from "./components/UserStatsReport";

const App = () => {
  return (
    <>
	<Toaster position="top-right" reverseOrder={false} />
    <Router>
      <Routes>
        <Route path="/events" element={<EventList />} />
        <Route path="/events/create-event" element={<CreateEvent />} />
        <Route path="/events/edit-event/:id" element={<EditEvent />} />
        <Route path="/events/view-event/:id" element={<ViewEvent />} />
        <Route path="/events/join-event/:id/:userId" element={<RegistrationForm />} />
        <Route path="/events/sm-join-event/:id/:userId" element={<SimpleRegistration />} />
        <Route path="/events/sendEventUsersAnEmail/:eventId" element={<EmailForm />} />
        <Route path="/event-questions/:eventId" element={<EventQuestionsForm />} />
        <Route path="/registration/:eventId/:userId" element={<RegistrationDetails />} />
        <Route path="/events/create-revenue-event" element={<CreateRevenueEvent />} />
        <Route path="/events/view-revenue-event/:id" element={<RevenueViewEvent />} />
        <Route path="/events/map" element={<MapBoxGPSComponent />} />
        <Route path="/events/gpx" element={<MapWithGpx />} />
        <Route path="/events/otggpx/:eventId" element={<OTGMapWithGpx />} />
        <Route path="/events/eventsmap" element={<OTGEventsMap />} />
        <Route path="/events/campmap" element={<CampMap />} />
        <Route path="/events/camps" element={<CampMap />} />
        <Route path="/events/mapload" element={<CampDataUpload />} />
        <Route path="/events/camps/:camp_location_id/edit/:userId" element={<CampDetailsEditor />} />
        <Route path="/events/campmap/addLocation" element={<AddLocationForm />} />
        <Route path="/events/otgcampdetails/:camp_location_id" element={<CampDetailsView />} />
        <Route path="/events/audit" element={<AuditLog />} />
        <Route path="/events/site_report/:camp_location_id" element={<SiteReportForm />} />
        <Route path="/events/site_reports" element={<SiteReportsView />} />
        <Route path="/events/userstats" element={<UserStatsReport />} />
      </Routes>
    </Router>
    </>
  );
};

export default App;

